
export const en_symbols: Record<string, string> = {
  "&": "/ænd/",
  "/": "/sɫæʃ/",
  "@": "/æt/",
  "©": "/ˈkɑpiˌɹaɪt/",
  "$": "/ˈdɑɫɝ/",
  "=": "/ˈikwəɫz/", "≠": "/ˈnɑtˈikwəɫtu/",
  ">": "/ˈɡɹeɪtɝˌðæn/",
  "<": "/ˈɫɛsˌðæn/",
  "%": "/pɝˈsɛnt/",
  "+": "/ˈpɫəs/",
  "*": "/ˈstɑɹ/",
  "~": "/ˈtɪɫdə/",
  "`": "/ˈbækˌtɪk/",
  "!": "/ˌɛkskɫəˈmeɪʃənˌmɑɹk/",
  "?": "/ˈkwɛstʃənˌmɑɹk/",
  "#": "/ˈhæʃˌtæɡ/",
  "^": "/ˈkɛɹət/",
  "×": "/ˈtaɪmz/",
  "(": "/ˈɫɛftˈpɛɹɛn/",
  ")": "/ˈɹaɪtˈpɛɹɛn/",
  "{": "/ˈɫɛftˈbɹeɪs/",
  "}": "/ˈɹaɪtˈbɹeɪs/",
  "[": "/ˈɫɛftˌskwɛɹˈbɹækɪt/",
  "]": "/ˈɹaɪtˌskwɛɹˈbɹækɪt/",
  "-": "/ˈdæʃ/",
  "−": "/ˈmaɪnəs/",
  "_": "/ˈəndɝˌskɔɹ/",
  "|": "/ˌvɝtɪkəɫˈbɑɹ/",
  "\\": "/ˈbækˌsɫæʃ/",
  ":": "/ˈkoʊɫən/",
  ";": "/ˈsɛməˌkoʊɫən/",
  "'": "/ˈkwoʊt/",
  '"': "/ˈkwoʊt/",
  ",": "/ˈkɑmə/",
  ".": "/ˈpɪɹiəd/",
  "°": "/dɪˈɡɹi/",
  "€": "/ˈjɝˌoʊ/",
  "£": "/ˈpaʊnd/",
  "√": "/ˌskwɛɹˈɹut/",
  "§": "/ˈsɛkʃən/",

  "0": "ˈziɹoʊ", "1": "ˈwən",
  "2": "ˈtu", "3": "ˈθɹi",
  "4": "ˈfɔɹ", "5": "ˈfaɪv",
  "6": "ˈsɪks", "7": "ˈsɛvən",
  "8": "ˈeɪt", "9": "ˈnaɪn",
  "½": "/ˌwənˈhæf/",
  "⅓": "/ˌwənˈθɝd/", "⅔": "/ˌtuˈθɝdz/",
  "¼": "/ˌwənˈfɔɹθ/", "¾": "/ˌθɹiˈfɔɹs/",

  "Α": "/ˈæɫfə/", "α": "/ˈæɫfə/",
  "Β": "/ˈbeɪtə/", "β": "/ˈbeɪtə/",
  "Γ": "/ˈɡæmə/", "γ": "/ˈɡæmə/",
  "Δ": "/ˈdɛɫtə/", "δ": "/ˈdɛɫtə/",
  "Ε": "/ˈɛpsəˌɫɑn/", "ε": "/ˈɛpsəˌɫɑn/",
  "Ζ": "/ˈzeɪtə/", "ζ": "/ˈzeɪtə/",
  "Η": "/ˈeɪtə/", "η": "/ˈeɪtə/",
  "Θ": "/ˈθeɪtə/", "θ": "/ˈθeɪtə/",
  "Ι": "/ˌaɪˈoʊtə/", "ι": "/ˌaɪˈoʊtə/",
  "Κ": "/ˈkæpə/", "κ": "/ˈkæpə/",
  "Λ": "/ˈɫæmdə/", "λ": "/ˈɫæmdə/",
  "Μ": "/ˈmu/", "μ": "/ˈmu/",
  "Ν": "/ˈnu/", "ν": "/ˈnu/",
  "Ξ": "/ˈksi/", "ξ": "/ˈksi/",
  "Ο": "/ˈoʊməkɹɑn/", "ο": "/ˈoʊməkɹɑn/",
  "Π": "/ˈpaɪ/", "π": "/ˈpaɪ/",
  "Ρ": "/ˈɹoʊ/", "ρ": "/ˈɹoʊ/",
  "Σ": "/ˈsɪɡmə/", "σ": "/ˈsɪɡmə/", "ς": "/ˈsɪɡmə/",
  "Τ": "/ˈtaʊ/", "τ": "/ˈtaʊ/",
  "Υ": "/ˈjupsəɫɑn/", "υ": "/ˈjupsəɫɑn/",
  "Φ": "/ˈfaɪ/", "φ": "/ˈfaɪ/",
  "Χ": "/ˈkaɪ/", "χ": "/ˈkaɪ/",
  "Ψ": "/ˈsaɪ/", "ψ": "/ˈsaɪ/",
  "Ω": "/oʊˈmɛɡə/", "ω": "/oʊˈmɛɡə/",
  "ℵ": "/ˈeɪɫɪf/",

  // IPA vowels
  "æ": "/ˈæʃ/",		// ash
  "ɐ": "/ˌtɝndˈeɪ/",		// turned a
  "ɑ": "/ˌskɹɪptˈeɪ/",		// script a
  "ɒ": "/ˈtɝndˌskɹɪptˈeɪ/",		// turned script a
  "ɘ": "/ɹiˈvɝstˈi/",		// reversed e
  "ɛ": "/ˈɛpsəˌɫɑn/",		// epsilon
  "ɜ": "/ɹiˌvɝstˈɛpsəˌɫɑn/",		// reversed epsilon
  "ɞ": "/ˈkɫoʊzdɹiˌvɝstˈɛpsəˌɫɑn/",		// closed reversed epsilon
  "ə": "/ˈʃwɑ/",		// schwa
  "ɚ": "/ˈʃwɑɹ/",		// schwar
  "ɝ": "/ˈɑɹˌkəɫɝdɹiˌvɝstˈɛpsəˌɫɑn/",   // r-colored reversed epsilon
  "ɨ": "/ˌbɑɹdˈaɪ/",		// barred i
  "ɪ": "/ˌsmɔɫˌkæpətəɫˈaɪ/",		// small capital I
  "ɔ": "/ˌoʊpənˈoʊ/",		// open o
  "ɵ": "/ˌbɑɹdˈoʊ/",		// barred o
  "ø": "/ˌsɫæʃtˈoʊ/",		// slashed o
  "œ": "/ˈɫoʊɝˌkeɪsˈoʊˈi/",		// lower case o e
  "ɶ": "/ˌsmɔɫˌkæpətəɫˈoʊˈi/",		// small capital o e
  "ʉ": "/ˌbɑɹdˈju/",		// barred u
  "ʊ": "/ˈjupsəɫɑn/",		// upsilon
  "ɤ": "/ˈɹæmzˌhɔɹnz/",		// ram's horns
  "ʌ": "/ˈtɝndˈvi/",		// turned v
  "ɯ": "/ˈtɝndˈɛm/",		// turned m
  "ʏ": "/ˌsmɔɫˌkæpətəɫˈwaɪ/",		// small capital Y
  // IPA consonants
  "ç": "/səˈdɪɫə/",
  "ð": "/ˈɛð/",	// eth
  "ɣ": "/ˈɡæmə/", // gamma
  "ɫ": "/ˈdɑɹkˈɛɫ/",	// dark l
  "ŋ": "/ˈɛŋ/",	// eng
  "ɹ": "/ˈtɝndˈɑɹ/",	// turned r
  "ʃ": "/ˈɛʃ/",	// esh
  "ʒ": "/ˈɛʒ/",	// ezh
  "ʔ": "/ˈɡɫɑtəɫˈstɑp/",  // glottal stop
  // other
  "ˈ": "/ˈpɹaɪˌmɛɹiˈstɹɛs/", // primary stress
  "ˌ": "/ˈsɛkənˌdɛɹiˈstɹɛs/", // secondary stress
  "ː": "/ˈɫɔŋ/", // long
  "ˑ": "/ˈhæfˈɫɔŋ/", // half long
}
